import { Component, OnInit } from '@angular/core';
import { ResultsEventsGroupComponent } from '../../results-events-group/results-events-group.component';

@Component({
  selector: 'app-results-events-group-mobile',
  templateUrl: './results-events-group-mobile.component.html',
  styleUrls: ['./results-events-group-mobile.component.less']
})
export class ResultsEventsGroupMobileComponent extends ResultsEventsGroupComponent {

}
